import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import Text from '../../Text'
import {
  BirdviewState,
  DashboardTileTone,
} from '../DashboardBirdview.constants'
import { QA_NAME_DASHBOARD_BIRDVIEW_TILE } from '../DashboardBirdview.constants.qa'

import { checkHasDashboardTileDelta } from './DashboardTile.utils'
import { DashboardTileBadge } from './DashboardTileBadge'
import { DashboardTileDelta } from './DashboardTileDelta'
import { DashboardTileGrip } from './DashboardTileGrip'
import { DashboardTileValue } from './DashboardTileValue'

import * as styles from './DashboardTile.module.css'

function DashboardTile({
  Chart = null,
  Icon,
  chartProps,
  count,
  countTooltip,
  delta,
  deltaTone,
  dragHandle,
  label,
  state = BirdviewState.Normal,
  tone = DashboardTileTone.Info,
  onClick,
}) {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_DASHBOARD_BIRDVIEW_TILE })}
      className={classNames(styles.tile, { [styles.interactive]: onClick })}
      onClick={onClick}
    >
      {dragHandle ? <DashboardTileGrip /> : null}
      <span className={styles.details}>
        <Text isSecondary className={styles.label} title={label}>
          {label}
        </Text>
        <span className={styles.value}>
          <DashboardTileValue
            count={count}
            state={state}
            tooltip={countTooltip}
          />
          {checkHasDashboardTileDelta({ delta, state }) ? (
            <DashboardTileDelta {...delta} tone={deltaTone} />
          ) : null}
        </span>
      </span>
      {Chart ? (
        <span className={styles.chart}>
          <Chart {...chartProps} />
        </span>
      ) : (
        <DashboardTileBadge Icon={Icon} tone={tone} />
      )}
    </div>
  )
}

export default DashboardTile
